const state = {
  imagesID: [],
  statVisitorCount: undefined,
}

const getters = {
  imagesID: (state) => {
    return state.imagesID;
  },
  statVisitorCount: (state) => {
    return state.statVisitorCount;
  },
}
const actions = { 
}
const mutations = {
  SET_IMAGES_ID(state, { imagesID }) {
    state.imagesID = imagesID;
  },
  SET_STAT_VISITOR_COUNT(state, { statVisitorCount }) {
    state.statVisitorCount = statVisitorCount;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};